import { useState } from "react";
import { Mic, Square, SendHorizonal, Loader2 } from "lucide-react";
import { useSpeechInput } from "@/hooks/useSpeechInput";
import { Waveform } from "./Waveform";

const PLACEHOLDER = { English: ["Message…", "Listening…"], Hindi: ["संदेश लिखें…", "सुन रहा हूँ…"], Hinglish: ["Message likho…", "Sun raha hoon…"] };

export const InputBar = ({ onSend, disabled, lang = "English" }) => {
  const [text, setText] = useState("");
  const { recording, refining, stream, start, stop } = useSpeechInput({ lang, text, setText });

  const submit = () => {
    const t = text.trim();
    if (!t || disabled) return;
    setText("");
    onSend(t);
  };

  return (
    <footer className="sticky bottom-0 bg-white/90 backdrop-blur-md border-t border-slate-200/80 p-3 sm:p-4">
      {recording && <Waveform stream={stream} />}
      <div className="flex items-end gap-2 bg-white border border-slate-300 rounded-2xl px-2 py-1.5 focus-within:ring-2 focus-within:ring-indigo-500/30 focus-within:border-indigo-400 transition">
        <button
          data-testid="mic-record-button"
          onClick={recording ? stop : start}
          disabled={refining}
          aria-label={recording ? "Stop recording" : "Start voice input"}
          className={`shrink-0 w-10 h-10 rounded-full grid place-items-center transition-colors ${recording ? "bg-red-500 text-white" : "text-slate-500 hover:bg-slate-100"}`}
        >
          {refining ? <Loader2 size={18} className="animate-spin" /> : recording ? <Square size={16} /> : <Mic size={18} />}
        </button>
        <textarea
          data-testid="chat-input-textarea"
          value={text}
          rows={1}
          placeholder={recording ? PLACEHOLDER[lang][1] : refining ? "Polishing your words…" : PLACEHOLDER[lang][0]}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && (e.preventDefault(), submit())}
          className="flex-1 resize-none bg-transparent outline-none text-[15px] py-2.5 max-h-40 text-slate-900 placeholder:text-slate-400"
          style={{ height: "auto" }}
          onInput={(e) => { e.target.style.height = "auto"; e.target.style.height = `${Math.min(e.target.scrollHeight, 160)}px`; }}
        />
        <button
          data-testid="send-message-button"
          onClick={submit}
          disabled={!text.trim() || disabled}
          aria-label="Send"
          className="shrink-0 w-10 h-10 rounded-full grid place-items-center bg-slate-900 text-white disabled:bg-slate-200 disabled:text-slate-400 hover:bg-slate-700 transition-colors"
        >
          <SendHorizonal size={18} />
        </button>
      </div>
    </footer>
  );
};
